import { getFormValues, getFormMeta, isDirty, isValid } from 'redux-form'
import _ from 'common-tools/LodashHelper'

export const FormValues = (formName, fieldList) => {
  return (state) => {
    let ret = {}
    let fieldListValues = []
    let formData = getFormValues(formName)(state) || {}

    if (_.isArray(fieldList)) {
      fieldListValues = fieldList
    } else {
      fieldListValues.push(fieldList)
    }

    _.forEach(fieldListValues, (f) => {
      if (_.isString(f)) {
        let fieldValue = _.get(formData, f)
        _.set(ret, f, fieldValue)
      }
      if (_.isPlainObject(f)) {
        let fieldValue = _.get(formData, f.sourceProp)
        _.set(ret, f.destProp, fieldValue)
      }
      if (_.isFunction(f)) {
        let customValue = f(formData)
        _.set(ret, customValue.prop, customValue.value)
      }
    })
    return ret
  }
}

export const FormData = (formName, destProp = 'formData') => {
  return (state) => {
    let ret = {}
    ret[destProp] = getFormValues(formName)(state) || {}
    return ret
  }
}

export const FormFieldState = (formName, destProp = 'formFieldStates') => {
  return (state) => {
    let ret = {}
    let meta = getFormMeta(formName)(state) || {}
    ret[destProp] = meta
  }
}

export const FormState = (formName, destProp = 'formState') => {
  return (state) => {
    let ret = {}
    ret[destProp] = {
      IsDirty: isDirty(formName)(state),
      IsValid: isValid(formName)(state)
    }
    return ret
  }
}
